import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { EMPTY, throwError } from 'rxjs';
import { FormConfig, ObjectViewEvent } from '../core/models/dataContract.model';
import { ObjectView } from '../core/models/dynamicEditor.interface';
import { CanComponentDeactivate } from '../core/services/route-guard.service';
import { ConfigService } from '../core/services/config.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { EventDispatcherService } from '../services/event-dispatcher.service';

@Component({
  selector: 'app-form-view',
  templateUrl: './form-view.component.html',
  styleUrls: ['./form-view.component.scss'],
  standalone: false
})
export class FormViewComponent
  extends ObjectView
  implements OnInit, OnDestroy, CanComponentDeactivate {
  uiType: string;
  uiSetting: FormConfig;

  blurLevel: number;

  errorMessage = '';

  defaultChildrenQuery = `/*[ocgParentRef='%ParentID%']`;

  currentID: string;
  currentType: string;

  constructor(injector: Injector, private config: ConfigService, private dispatcher: EventDispatcherService) {
    super(injector);
  }

  ngOnInit(): void {
    this.errorMessage = '';

    this.blurLevel = this.config.getConfig('blurLevel', 1);
    this.subscription.add(
      this.route.params
        .pipe(
          switchMap(() => {
            this.currentID = this.route.snapshot.paramMap.get('id');
            if (this.currentID) {
              return this.resource.getResourceByID(this.currentID, ['DisplayName']);
            } else {
              throwError('key_resourceNotFound');
            }
          }),
          tap(() => {
            this.swap.broadcast({ name: 'exit-edit-mode', parameter: true });
            this.currentType = this.route.snapshot.paramMap.get('type');
            if (this.currentType) {
              if (!this.uiType) {
                this.uiType = this.currentType;
                this.uiSetting =
                  this.resource.primaryViewSetting.editingView[this.uiType];
                if (this.uiSetting) {
                  this.initComponent('editingView', this.uiType);
                } else {
                  const typeNames = Object.keys(this.resource.schema).filter(
                    (s: string) => s.toLowerCase() === this.uiType
                  );
                  if (typeNames && typeNames.length === 1) {
                    this.uiSetting = this.genericEditingForm;
                    this.uiSetting.objectType = typeNames[0];
                    this.initComponent('editingView', typeNames[0]);
                  } else {
                    throwError('key_typeNotFound');
                  }
                }
              } else {
                if (this.uiType !== this.currentType) {
                  this.uiType = this.currentType;
                  this.uiSetting =
                    this.resource.primaryViewSetting.editingView[this.uiType];
                  if (this.uiSetting) {
                    this.initComponent('editingView', this.uiType, false);
                  } else {
                    const typeNames = Object.keys(this.resource.schema).filter(
                      (s: string) => s.toLowerCase() === this.uiType
                    );
                    if (typeNames && typeNames.length === 1) {
                      this.uiSetting = this.genericEditingForm;
                      this.uiSetting.objectType = typeNames[0];
                      this.initComponent('editingView', typeNames[0]);
                    } else {
                      throwError('key_typeNotFound');
                    }
                  }
                }
              }
              console.log(this.viewSetting);
            } else {
              throwError('key_typeNotFound');
            }
          }),
          catchError((err: HttpErrorResponse | string) => {
            this.errorMessage = typeof err === 'string' ? err : err.error;
            return EMPTY;
          })
        )
        .subscribe()
    );
  }

  ngOnDestroy() {
    this.swap.broadcast({ name: 'exit-edit-mode', parameter: true });
    // this.onCancelSetting();
    this.subscription.unsubscribe();
  }

  canDeactivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ) {
    return this.dispatcher.viewCanDeactivate(new ObjectViewEvent(
      'viewCanDeactivate',
      null,
      this.tabView, {
      currentRoute,
      currentState,
      nextState,
      editMode: this.swap.editMode,
      currentID: this.currentID,
      currentType: this.currentType,
    }
    ));
  }

  onSettingsCancel() {
    this.onCancelSetting(true);
  }
}
